import React from 'react';
import { useParams } from 'react-router-dom';

import { fieldObjectContratos } from './auxiliarContratos';
import { SubAbasContratos, SubAbasContratosNovo } from './subabasContratos';
import DestaquesComponente from '../../../../components/Destaques';
import { ENTITY } from '../../../../utils/entityNames';

const ContratosDestaque: React.FC = () => {
  // const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="contrato"
      id_tab={fichaID}
      retorno="/daf/proaq/contratos"
      arquivo_export="sisaf_proaq_contratos_destaques.xlsx"
      fieldObject={fieldObjectContratos}
      subAbas={
        fichaID !== 'undefined'
          ? SubAbasContratos(fichaID)
          : SubAbasContratosNovo
      }
      entity={ENTITY.ENTITY_Contrato}
    />
  );
};

export default ContratosDestaque;
